import { camelcaseKeys } from 'src/utils/camelize-keys';

import {
  PlanAssignment,
  PlanBlock,
  PlanWorkout,
  WorkoutPlan,
  WorkoutPlanSearchResult,
} from './_types';

export function normalizePlanAssignment(assignment: any): PlanAssignment {
  const normalized = camelcaseKeys(assignment, { deep: true });

  // Handle pluck_columns response where delayInterval is inside meta
  if (normalized.meta && !normalized.delayInterval) {
    normalized.delayInterval = normalized.meta.delayInterval ?? normalized.meta.delay_interval ?? '0';
  }

  return normalized;
}

export function normalizeWorkoutPlan(workoutPlan: any): WorkoutPlan {
  return camelcaseKeys(workoutPlan, { deep: true });
}

export function normalizeWorkoutPlanSearchResult(
  result: any
): WorkoutPlanSearchResult {
  const { json } = result.data;
  const camelized = camelcaseKeys(json);
  const searchResult: WorkoutPlanSearchResult = {
    id: camelized.id,
    name: result.term,
    aliases: result.aliases,
  };

  return searchResult;
}

export function normalizePlanWorkout(planWorkout: any): PlanWorkout {
  return camelcaseKeys(planWorkout, { deep: true });
}

export function normalizePlanBlock(planBlock: any): PlanBlock {
  return camelcaseKeys(planBlock, { deep: true });
}
